import { Box, IconButton, Typography } from "@mui/material";
import { CommonStyle, ControlledForm } from "Components";
import CstmBtn from "Components/CstmBtn";
import ImgPath from "Constant/Imgs";
import { RouteUrls } from "Constant/RouteUrls";
import { HeaderInitialStateType } from "DataTypes/Redux";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CheckStringEmpty } from "Utils/common";
import CommonFormatter from "Utils/Common.Formatter";
import { PlanData } from "./Data";
import { useNavigate } from "react-router-dom";

export interface PlanDataType {
  id: number;
  text: string;
  category: "goals" | "intervention"
}

const PlanDetails: FC = () => {
  const navigate = useNavigate();
  const { organization }: HeaderInitialStateType = useSelector(
    (state: any) => state?.header
  );
  const [dataArr, setDataArr] = useState<PlanDataType[]>(PlanData);
  const [editChanges, setEditChanges] = useState<PlanDataType | null>(null);

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "upload patient",
      label: `${organization.name}'s Pre Approved Plans`,
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${RouteUrls.preApprovedPlan}`,
      level: 2,
      link: RouteUrls.preApprovedPlan,
      navType: "org",
    });
  }, []);

  const handleAddGoal: () => void = () => {
    const newObj: PlanDataType = {
      category: "goals",
      id: dataArr.length + 1,
      text: ""
    }
    setDataArr([...dataArr, newObj]);
    setEditChanges(newObj);
  };

  const handleAddInter: () => void = () => {
    const newObj: PlanDataType = {
      category: "intervention",
      id: dataArr.length + 1,
      text: ""
    }
    setDataArr([...dataArr, newObj]);
    setEditChanges(newObj);
  };

  const handleSaveChanges: () => void = () => {
    setEditChanges(null);
    setDataArr([...dataArr.slice(0, 11),])
  };

  const handleClose: () => void = () => {
    setEditChanges(null);
    setDataArr([...dataArr.slice(0, 11),])
  };

  const AddEditDeletePlanPoints: (
    data: PlanDataType
  ) => JSX.Element = (data) => {
    if (editChanges && editChanges.id == data.id) {
      return (
        <Box key={data.id} sx={{ ...sxTextBox }}>
          <ControlledForm.InputApi
            id="EditText"
            inputVal={editChanges.text}
            inputChange={(val) => {
              setEditChanges({
                ...editChanges,
                text: CheckStringEmpty(val)
              })
            }}
          />
          <Box display="flex" p={1}>
            <IconButton
              sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
              onClick={handleSaveChanges}
            >
              <ImgPath.SaveIcon />
            </IconButton>
            <IconButton
              sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
              onClick={handleClose}
            >
              <ImgPath.CloseIcon />
            </IconButton>
          </Box>
        </Box>
      )
    }
    else {
      return (
        <Box key={data.id} sx={{ ...sxTextBox }}>
          <Typography variant="body2" p={1}>
            {data.text}
          </Typography>
          <Box display="flex" p={1}>
            <IconButton
              sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
              onClick={() => setEditChanges(data)}
            >
              <ImgPath.EditOutlined />
            </IconButton>
            <IconButton
              sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
            >
              <ImgPath.DeleteOutline />
            </IconButton>
          </Box>
        </Box>
      )
    }
  }

  return (
    <Box height="91%" sx={{ ...CommonStyle.sxWhiteBox, overflow: "auto" }}>
      <Box sx={{ p: 2 }}>
        <Typography mb={2}><b>Problem Name :</b> Asthma</Typography>
        <Box width={"50%"}>
          <Typography color="black" fontWeight={"bold"}>Goals</Typography>
          {dataArr.filter(el => el.category == "goals").map(el => {
            return AddEditDeletePlanPoints(el)
          })}
          <CstmBtn
            label="Add More"
            onClick={handleAddGoal}
            sxProps={{ mt: 1 }}
            disable={editChanges ? true : false}
          />
          <Typography color="black" fontWeight={"bold"} mt={4}>
            Interventions
          </Typography>
          {dataArr.filter(el => el.category == "intervention").map(el => {
            return AddEditDeletePlanPoints(el)
          })}
          <CstmBtn
            label="Add More"
            onClick={handleAddInter}
            sxProps={{ mt: 1 }}
            disable={editChanges ? true : false}
          />
          <Box textAlign={"end"}>
            <CstmBtn
              label="Save Changes"
              onClick={() => navigate(-1)}
              sxProps={{ mt: 1, p: 2 }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
};

export default PlanDetails;

const sxTextBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid",
  borderColor: "custom.main",
  borderRadius: "5px",
}